"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var createReplacementToken = function createReplacementToken(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    contextKey: (0, _utils.getProp)(fields, 'contextKey'),
    useTextFrom: (0, _utils.getProp)(fields, 'useTextFrom'),
    translationPath: (0, _utils.getProp)(fields, 'translationPath')
  };
};
var _default = createReplacementToken;
exports["default"] = _default;